import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export const StickyCTA = ({
  showNewImage = false
}) => {
  return <div className="sticky-cta" data-id="element-254">
      <div className="sticky-cta-inner" data-id="element-255">
        <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-256">
          Instant Lipedema Relief or Money Back!
        </h3>
        <div className="product-image mb-4 bg-gray-100 rounded-lg overflow-hidden" data-id="element-257">
          <div className="aspect-w-1 aspect-h-1 relative w-full" style={{
          paddingBottom: '100%'
        }} data-id="element-258">
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center" data-id="element-259">
              <img src={showNewImage ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/jDyiVRx4e66UhAKcWCiTqH/ChatGPT_Image_29_%CE%A3%CE%B5%CF%80_2025%2C_07_07_55_%CE%BC.%CE%BC..png' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/qR1wmVv8oVuvNVLcM9qdQW/Screenshot_2025-09-29_at_18.54.07.png'} alt="Elivara Compression Leggings" className="object-contain h-full w-full" data-id="element-260" />
            </div>
          </div>
        </div>
        <div className="customer-reviews mb-4" data-id="element-261">
          <div className="flex items-center justify-center mb-1" data-id="element-262">
            <div className="flex" data-id="element-263">
              {[1, 2, 3, 4, 5].map((star, index) => <StarIcon key={index} className={`h-5 w-5 ${index < 5 ? 'text-yellow-400' : 'text-gray-300'} fill-current`} data-id="element-264" />)}
            </div>
            <span className="ml-2 text-sm font-semibold" data-id="element-265">4.8 out of 5</span>
          </div>
          <p className="text-center text-sm text-gray-600" data-id="element-266">
            3,791 customer ratings
          </p>
        </div>
        <div className="ratings-breakdown mb-4 px-2" data-id="element-267">
          {[{
          label: '5★',
          percentage: 90
        }, {
          label: '4★',
          percentage: 7
        }, {
          label: '3★',
          percentage: 2
        }, {
          label: '2★',
          percentage: 0
        }, {
          label: '1★',
          percentage: 1
        }].map((rating, index) => <div key={index} className="flex items-center text-sm mb-1" data-id="element-268">
              <span className="w-8" data-id="element-269">{rating.label}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-2.5" data-id="element-270">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
              width: `${rating.percentage}%`
            }} data-id="element-271"></div>
              </div>
              <span className="w-8 text-right" data-id="element-272">{rating.percentage}%</span>
            </div>)}
        </div>
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center mb-2 block" data-id="element-273">
          CHECK AVAILABILITY →
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-274">
          Limited time offer - Fast FREE shipping across the US
        </p>
      </div>
    </div>;
};